import { Link } from 'react-router-dom';

export type EntityType = 'product' | 'location' | 'supply' | 'storageLocation';

const pathByType: Record<EntityType, (id: string) => string> = {
  product: (id) => `/products/${id}`,
  location: (id) => `/locations/${id}`,
  supply: (id) => `/supplies/${id}`,
  storageLocation: (id) => `/storage-locations/${id}`,
};

interface EntityLinkProps {
  type: EntityType;
  id: string | null | undefined;
  label: string;
  className?: string;
  tab?: string;
}

export function EntityLink({ type, id, label, className = '', tab }: EntityLinkProps) {
  if (!id) {
    return <span className={className}>{label}</span>;
  }

  const base = pathByType[type](id);
  const to = tab ? `${base}?tab=${tab}` : base;

  return (
    <Link
      to={to}
      className={`text-amber-600 dark:text-amber-450 hover:underline font-medium ${className}`}
    >
      {label}
    </Link>
  );
}
